import client from "./base"

export type ISearchThuocsiProduct = {
    where: any,
    limit: number,
    offset: number
}

export const searchThuocsiProduct = async (filter: {
    where: any,
    limit: number,
    offset: number
}) => {

    let url = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/b2b/thuocsi-products`;

    if (filter) {
        console.log('filter: ', filter);
        url += `?filter=` + encodeURIComponent(JSON.stringify(filter));
    }

    return await client.get(
        url,
        {
            auth: {
                username: process.env.REACT_APP_THUOCSI_USERNAME || '',
                password: process.env.REACT_APP_THUOCSI_PASSWORD || ''
            }
        }
    ).then(res => {
        return res?.data;
    })
}

export const searchCompareThuocsiPrice = async (filter: {
    where?: any,
    order?: string | string[],
    limit?: number,
    offset?: number
}, medxOnly: boolean) => {

    let url = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/b2b/thuocsi-products/compare-price`;

    return await client.get(url, { params: { filter, medxOnly } })
        .then(res => {
            console.log('res?.data: ', res?.data);
            return res?.data;
        })

}

export const countCompareThuocsiPrice = async (where: any, medxOnly: boolean) => {

    let url = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/b2b/thuocsi-products/compare-price/count`;

    return await client.get(url, { params: { where: where, medxOnly } })
        .then(res => {
            console.log('res.data.count: ', res.data.count);
            return res.data.count;
        })
}

export const thuocsiCrawlDates = async () => {

    let url = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/b2b/thuocsi-products/crawl-dates`;

    return await client.get(url)
        .then(res => {
            console.log('crawl dates: ', res.data);
            return res.data;
        })
}